/**
 * StandOut WordPress Theme
 * Main entry point
 *
 * @package StandOut
 * @since 2.0.0
 */
import "../css/main.css";
// Flag that scripting is available, so progressive-enhancement fallbacks
// (e.g. the product filter submit buttons) can hide themselves.
document.documentElement.classList.add("js");
import "./libraries/_initialize";
import "./theme/_initialize";
import "./templates/_initialize";
